import { render, staticRenderFns } from "./selectApi.vue?vue&type=template&id=48cf8cbf&scoped=true"
import script from "./selectApi.vue?vue&type=script&lang=js"
export * from "./selectApi.vue?vue&type=script&lang=js"
import style0 from "./selectApi.vue?vue&type=style&index=0&id=48cf8cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf8cbf",
  null
  
)

export default component.exports